import React, { useRef, useEffect, useState  } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // IMPORTANTE
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
//import logo from "../logo.svg"; // Importar logo
import { Card } from 'react-bootstrap';
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Toolbar } from 'primereact/toolbar';
import { SplitButton } from 'primereact/splitbutton';
import { getFacturas}from '../api/facturaService'; 
import { getClientes } from '../api/clientesService';//getClientes
import { format ,startOfToday,
  endOfToday,
  startOfYesterday,
  endOfYesterday,
  subDays,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear} from 'date-fns';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { ListBox } from 'primereact/listbox';
import {getImpuestos}  from "../api/monedaFormaPagoService"


function MainReportes() {
const [seleccionados, setSeleccionados] = useState([]);
const [rangoFechas, setRangoFechas] = useState(null);
const [rangoSeleccionado, setRangoSeleccionado] = useState(null);
const [cliente, setCliente] = useState(null); 
const [clientes, setClientes] = useState([]);
const [impuestos, setImpuestos] = useState([]);


useEffect(() =>{
  const fetchData = async () => 
    {
      const data = await getClientes();  
      const activas = data.filter(e => e.activo === true); // o e.estatus === "Activo"
      setClientes(activas); 
    };
   
  fetchData();
}, []);

// useEffect(() => {
//   getImpuestos().then(data =>
//     setImpuestos(data.map(i => ({
//       label: i.nombre,
//       value: i.clave
//     })))
//   );
// }, []);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getImpuestos();
      console.log(data);
      //console.log('CLIENTES DESDE EL BACKEND:', data);// 👈 aquí revisamos qué viene
      setImpuestos(data.map(i => ({
      label: i.abreviatura,
      value: i.abreviatura})));
    };

    fetchData();
  }, []);
  const opciones = [
  { label: 'Factura Pagada', value: 'PAGADA' },
  { label: 'Factura Parcial', value: 'PARCIAL' },
  { label: 'Factura en Adeudo', value: 'ADEUDO' }
];
const opcionesRango = [
  { label: 'Hoy', value: 'hoy' },
  { label: 'Ayer', value: 'ayer' },
  { label: 'Últimos 7 días', value: '7dias' },
  { label: 'Últimos 30 días', value: '30dias' },
  { label: 'Este mes', value: 'mesActual' },
  { label: 'Mes pasado', value: 'mesPasado' },
  { label: 'Este año', value: 'anioActual' },
  { label: 'Rango personalizado', value: 'custom' }
];


 const startContent = (
        <React.Fragment>
            <h5>Reportes genéricos</h5>
        </React.Fragment>
    );
    const itemTemplate = (option) => {
  return (
    <div className="flex align-items-center gap-2">
      <Checkbox checked={seleccionados.includes(option.value)} />
      <span>{option.label}</span>
    </div>
  );
};

const aplicarRango = (tipo) => {
  let inicio, fin;

  switch (tipo) {
    case 'hoy':
      inicio = startOfToday();
      fin = endOfToday();
      break;

    case 'ayer':
      inicio = startOfYesterday();
      fin = endOfYesterday();
      break;

    case '7dias':
      inicio = subDays(new Date(), 6);
      fin = new Date();
      break;

    case '30dias':
      inicio = subDays(new Date(), 29);
      fin = new Date();
      break;

    case 'mesActual':
      inicio = startOfMonth(new Date());
      fin = endOfMonth(new Date());
      break;

    case 'mesPasado':
      const lastMonth = subDays(startOfMonth(new Date()), 1);
      inicio = startOfMonth(lastMonth);
      fin = endOfMonth(lastMonth);
      break;

    case 'anioActual':
      inicio = startOfYear(new Date());
      fin = endOfYear(new Date());
      break;

    case 'custom':
      return;

    default:
      return;
  }

  setRangoFechas([inicio, fin]);
};



return (
  <>
    <h4>Reportes</h4>  
    <Card>
        <Toolbar  start={startContent}  >  </Toolbar>  
    </Card>
    <Card>
      <div class="grid">
        <div class="col-3">
          <ListBox
        value={seleccionados}
        options={opciones}
        onChange={(e) => setSeleccionados(e.value)}
        itemTemplate={itemTemplate}
        multiple
        checkmark
        optionLabel="label"
        className="w-full " />

        </div>
      <div class="col-8">
        <div class="row">
          <div><strong>Reporte :</strong></div>
         
          <Dropdown className="col-8"></Dropdown>
        </div>
        <div class="row">
          <div><strong>Fechas :</strong></div>
          <Dropdown  value={rangoSeleccionado}
    options={opcionesRango}
    onChange={(e) => {
      setRangoSeleccionado(e.value);
      aplicarRango(e.value);
    }}
    placeholder="Seleccionar rango"
    className="col-5" />
    {rangoSeleccionado === 'custom' && (
    <Calendar
      value={rangoFechas}
      onChange={(e) => setRangoFechas(e.value)}
      selectionMode="range"
      readOnlyInput
      dateFormat="dd/mm/yy"
      placeholder="Rango personalizado"
       className="col-3"
    />
  )}

        </div>
        <div class="row">
        <div><strong>Todos los clientes :</strong></div>
        <Dropdown className="col-1"></Dropdown>
          <Dropdown value={cliente} onChange={(e) => setCliente(e.value)} options={clientes}   
                placeholder="Selecciona un cliente"  className="col-7" optionLabel="razonSocial"
                itemTemplate={(option) => `${option.ruc} - ${option.razonSocial}`}
                valueTemplate={(option, props) => option ? `${option.ruc} - ${option.razonSocial}` : props.placeholder} ></Dropdown>
        </div>

      </div>
     
      
       </div>
    </Card>

  </>
);
}

export default MainReportes; 
